import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { requireClerkCoachAuth } from "~/lib/coach-middleware";
import { OfferStatus } from "~/lib/schemas/db-enums";
import type { OfferLifecycleState } from "~/lib/server/offer-lifecycle";

export type { OfferLifecycleState };

/** Publish, retire, or republish one of the signed-in coach's offers. */
export const changeOfferStatus = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .validator(
    z.object({ offerId: z.string().uuid(), to: z.nativeEnum(OfferStatus) }),
  )
  .handler(async ({ data, context }): Promise<OfferLifecycleState> => {
    const { transitionOfferStatus } =
      await import("~/lib/server/offer-lifecycle");
    return transitionOfferStatus({
      coachId: context.coach.id,
      offerId: data.offerId,
      to: data.to,
    });
  });

/** Make one of the signed-in coach's published standard offers the main one. */
export const makeMainOffer = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .validator(z.object({ offerId: z.string().uuid() }))
  .handler(async ({ data, context }): Promise<OfferLifecycleState> => {
    const { setMainOffer } = await import("~/lib/server/offer-lifecycle");
    return setMainOffer({ coachId: context.coach.id, offerId: data.offerId });
  });
